<ng-container *ngIf="isExternal">
  <h2 class="predictor-submission-title text-center">{{ 'fgbcl.predictor.external.form.submitted.title' | translate }}</h2>
  <p class="submission-description text-center">
    {{ 'fgbcl.predictor.external.form.submitted.description' | translate }}
  </p>
    <div class="fgbcl-games-predictor-question-section-countdown">
    <div class="fgbcl-games-predictor-countdown-end-text">
      {{ 'fgbcl.game.predictor.ends.text' | translate }}:
    </div>
    <fgbcl-countdown-v2 [endDateTime]="predictorResult.EndDate" completeText="Ended"></fgbcl-countdown-v2>
  </div>
</ng-container>

<fgbcl-game-result
  [showShareWithFriendButton]="true"
  [redirectPageURL]="sharedRedirectURL"
  [gameDetails]="predictorResult"
  [groupType]="groupType"
  [isExternal]="isExternal"
>
  <ng-container *ngIf="submissionFormTemplate">
    <ng-container *ngTemplateOutlet="submissionFormTemplate"></ng-container>
  </ng-container>
</fgbcl-game-result>

<ng-container *ngIf="!isExternal">
  <ng-container *ngFor="let res of predictorValueQuestions; let i = index">
    <div
      class="fgbcl-games-predictor-result-question-card"
      [ngClass]="{
        'fgbcl-game-correct-prediction': res.IsCorrect,
        'fgbcl-game-wrong-prediction': !res.IsCorrect,
        'fgbcl-games-predictor-question-card-tall': res.AnswerDisplayType == answerDisplayEnum.ImageAndText,
      }"
    >
      <div
        class="fgbcl-games-predictor-question-number-circle"
        [ngClass]="{
          'fgbcl-game-correct-prediction': res.IsCorrect,
          'fgbcl-game-wrong-prediction': !res.IsCorrect,
        }"
      >
        {{ i + 1 }}
      </div>
  
      <div class="fgbcl-game-question-text">
        {{ res.Title }}
      </div>
  
      <ng-container *ngIf="res.AnswerDisplayType == answerDisplayEnum.Score">
        <fgbcl-answer-counter-predictor-result
          [answers]="res.Answers"
          [multiCounter]="true"
        ></fgbcl-answer-counter-predictor-result>
      </ng-container>
  
      <ng-container *ngIf="res.AnswerDisplayType == answerDisplayEnum.Counter">
        <fgbcl-answer-counter-predictor-result
          [answers]="res.Answers"
          [multiCounter]="false"
        ></fgbcl-answer-counter-predictor-result>
      </ng-container>
  
      <ng-container
        *ngIf="
          res.AnswerDisplayType == answerDisplayEnum.Dropdown ||
          res.AnswerDisplayType == answerDisplayEnum.Text ||
          res.AnswerDisplayType == answerDisplayEnum.ImageAndText
        "
      >
        <fgbcl-answer-text-predictor-result [question]="res"></fgbcl-answer-text-predictor-result>
      </ng-container>
      <div class="fgbcl-predictor-prediction-text-section">
        <div class="fgbcl-predictor-correct-answer-text" *ngIf="res.IsCorrect">
          {{ 'fgbcl.predictor.correct.answer.text' | translate }}
        </div>
        <div class="fgbcl-predictor-incorrect-answer-text" *ngIf="!res.IsCorrect">
          {{ 'fgbcl.predictor.incorrect.answer.text' | translate }}
        </div>
      </div>
      <div class="fgbcl-game-answer-point-section" *ngIf="getTotalPointsForQuestion(res.Id) >= 0">
        <div class="fgbcl-game-answer-point-block">
          <span class="material-icons align-middle fgbcl-game-emoji-events-icon">{{ pointIcon }}</span>
          <div class="fgbcl-game-answer-points">
            <span *ngIf="getTotalPointsForQuestion(res.Id) > 0">+</span>{{ getTotalPointsForQuestion(res.Id)
            }}<span class="mx-1">{{ 'fgbcl.predictor.point.text' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="fgbcl-game-back-to-game-button-section">
    <button class="fgbcl-game-back-to-game-button" (click)="closeModel()">
      {{ 'fgbcl.predictor.hub.back.button.text' | translate }}
    </button>
  </div>
</ng-container>
